import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { Roles } from '../constants/roles.constant'
import { NavigateRightService } from '../service/navigate-rights.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public authenticationService: AuthenticationService, public router: Router,
    private _navigateService: NavigateRightService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const menuName = route.data.menuName as string;
    const type = route.data.type as string;
    const menuWrights=this._navigateService.menuRights(menuName);
    const isAdmin = this.authenticationService.isAdministrator();
    if (!this.authenticationService.isAuthenticated()) {
      this.router.navigate([''],{queryParams:{'returnUrl':state.url}});
      return false;
    }
    else if (!this._navigateService.canView(menuName)) {
      isAdmin ? this.router.navigate(['dashboard']) : this.router.navigate(['attendance']);
      return false;
    }
    else if((type=='add'&& !menuWrights.canAdd) || (type=='edit'&& !menuWrights.canEdit))
    {
      isAdmin ? this.router.navigate(['dashboard']) : this.router.navigate(['attendance']);
      return false;
    }
    else
      return true;


    // const roles = route.data.roles as Array<string>;
    // if (roles !== undefined && roles.length !== 0) {

    //   if (roles.includes(Roles.ADMINISTRATOR)) {

    //     if (!this.authenticationService.isAdministrator()) {
    //       this.router.navigate(['']);
    //       return false;
    //     }
    //   } else {
    //     this.router.navigate(['']);
    //     return false;
    //   }
    // }
    
  }
}

